import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {SiteIncomeReportGrid} from "./grid";
import {submitSiteIncomeReport} from "../../../services/report/income";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily} from "../../../services/profile/profile";
import {getAgentsList} from "../../../services/agent/agent";
import {getFields} from "../../../services/field/field";
import {getFieldBranchesByFieldId} from "../../../services/branch/branch";
import FromToNumberField from "../../system/fromToNumberField";
import {downloadFile} from "../../../config";


export function SiteIncomeReportManagement() {

  const [siteIncomeReport, setSiteIncomeReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(5);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [agentId, setAgentId] = useState(null);
  const [fieldId, setFieldId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [serviceType, setServiceType] = useState(null);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [minAgentShare, setMinAgentShare] = useState(null);
  const [maxAgentShare, setMaxAgentShare] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitSiteIncomeReport(data, paginate);
    if (result.status === 200) {
      const {site_report, total_count} = result.data;
      setSiteIncomeReport(site_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (agentId) {
      data.agent_id = agentId;
    }

    if (fieldId) {
      data.field_id = fieldId;
    }

    if (branchId) {
      data.branch_id = branchId;
    }

    if (serviceType) {
      data.service_type = serviceType;
    }

    if (minPrice) {
      data.min_price = parseInt(minPrice);
    }

    if (maxPrice) {
      data.max_price = parseInt(maxPrice);
    }

    if (minAgentShare) {
      data.min_agent_share = parseInt(minAgentShare);
    }

    if (maxAgentShare) {
      data.max_agent_share = parseInt(maxAgentShare);
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [
    personId,
    agentId,
    fieldId,
    branchId,
    serviceType,
    minPrice,
    maxPrice,
    minAgentShare,
    maxAgentShare,
    gridCurrentPage,
    gridRowCount,
    sortBy,
    sortType
  ]);

  return (
    <div className="w-full">
      <Card className="pt-8 w-full">
        <CardHeader floated={true} shadow={false} className="rounded-none w-full">
          <div className="mb-8 flex items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">درآمد پلتفرم</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-2 xxl:grid-cols-3">

            <div className="flex flex-col">
              <SelectInput
                label={"کاربر"}
                defaultValue={personId}
                refreshSignal={personId}
                // multiselect={false}
                autoLoadService={getPersonsNameAndFamily}
                autoLoadRender={({name, family, phone, national_code}) => {
                  return name + " " + family + " - " + phone + " - " + national_code;
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"مباشر"}
                defaultValue={agentId}
                refreshSignal={agentId}
                // multiselect={false}
                autoLoadService={getAgentsList}
                autoLoadRender={({name, family, phone, national_code}) => {
                  return name + " " + family + " - " + phone + " - " + national_code;
                }}
                onChange={setAgentId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"رشته"}
                defaultValue={fieldId}
                autoLoadService={getFields}
                onChange={setFieldId}
                autoLoadRender={({title}) => {
                  return title
                }}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"گرایش"}
                defaultValue={branchId}
                refreshSignal={fieldId}
                autoLoadService={getFieldBranchesByFieldId}
                autoLoadServiceData={fieldId}
                autoLoadRender={({title}) => {
                  return title
                }}
                onChange={setBranchId}
              />
            </div>

            <div className="flex flex-col">
              <SelectInput
                label={"نوع سرویس"}
                options={[
                  {
                    "id": 'consultation',
                    "title": "مشاوره"
                  },
                  {
                    "id": 'service',
                    "title": "خدمات"
                  },
                ]}
                onChange={setServiceType}
              />
            </div>


            <FromToNumberField
              label="مبلغ"
              fromNumber={minPrice}
              setFromNumber={setMinPrice}
              toNumber={maxPrice}
              setToNumber={setMaxPrice}
            />

            <FromToNumberField
              label="سهم مباشر"
              fromNumber={minAgentShare}
              setFromNumber={setMinAgentShare}
              toNumber={maxAgentShare}
              setToNumber={setMaxAgentShare}
            />
          </div>

          <div className="flex flex-row justify-between">
            <Button variant="gradient" color="gray" onClick={() => {
              setPersonId(null)
              setAgentId(null)
              setFieldId(null)
              setBranchId(null)
              setMinPrice(null);
              setMaxPrice(null);
              setDateFrom(null);
              setDateTo(null);
            }} className="ml-1">
              <span>حذف فیلتر</span>
            </Button>

            {siteIncomeReport.length > 0 &&
              <Button size="sm" variant="outlined" onClick={() => {
                const data = filter();
                downloadFile("site_income_report_excel", data, "site income")
              }}>
                خروجی اکسل
              </Button>
            }
          </div>

          <SiteIncomeReportGrid
            siteIncomeReport={siteIncomeReport}
            setSortBy={setSortBy}
            sortType={sortType}
            setSortType={setSortType}
          />
        </CardBody>
        <CardFooterPaginator
          active={gridCurrentPage}
          setActive={setGridCurrentPage}
          totalRows={gridTotalRowCount}
          rowsCount={gridRowCount}
          setRowsCount={setGridRowCount}
          from={from}
          to={to}
        />
      </Card>
    </div>
  );
}